import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_warning_circle_red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2f6d02b6")

_pushScopeId("data-v-2f6d02b6")
const _hoisted_1 = {
  key: 0,
  class: "flex flex-row items-center p-2 bg-red-lp-1300 gap-x-2 w-full rounded-lg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "exclamation",
  class: "h-4"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "text-red-lp-100 font-normal text-12px" }, " Cut off time kargo sudah lewat, pilih ulang jadwal keberangkatan pesawat ", -1)
const _hoisted_4 = { class: "flex flex-col gap-6 w-full" }
const _hoisted_5 = {
  key: 0,
  class: "flex-col justify-start items-start gap-3 flex"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "text-black-lp-300 text-base font-semibold" }, " Lengkapi data booking ", -1)
const _hoisted_7 = { class: "gap-5 grid grid-cols-2 w-full" }
const _hoisted_8 = {
  key: 1,
  class: "self-stretch border border-gray-lp-400"
}
const _hoisted_9 = { class: "flex-col justify-start items-start gap-5 flex w-full" }
const _hoisted_10 = {
  key: 0,
  class: "text-black-lp-300 text-base font-semibold"
}
const _hoisted_11 = { class: "py-3" }
const _hoisted_12 = {
  key: 0,
  class: "text-gray-lp-500 text-center w-full"
}
const _hoisted_13 = { class: "py-3" }
const _hoisted_14 = {
  key: 0,
  class: "text-gray-lp-500 text-center w-full"
}
const _hoisted_15 = {
  key: 2,
  class: "flex flex-row gap-4 col-span-2"
}
const _hoisted_16 = { class: "flex flex-row justify-end gap-4 mt-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    buttonId: "button_x_modal_form_cargo_plane",
    class: "dialog-airport",
    modelValue: _ctx.showSelectAirport,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.showSelectAirport = $event)),
    title: 
      (_ctx.flowBooking.includes('rtc') && !_ctx.isEditCargo)
        ? 'Lengkapi data berikut'
        : _ctx.isEditCargo ? 'Pilih jadwal pesawat' : 'Bandara Tujuan'
    ,
    persistent: "",
    onReset: _ctx.cancelPopupAirport
  }, {
    default: _withId(() => [
      _createVNode("div", {
        style: {
      width: _ctx.isEditCargo ? '41vw' : '50vw',
      maxHeight: '70vh'
    },
        class: "space-y-3 overflow-auto"
      }, [
        (_ctx.isAllowEditCutoff())
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _hoisted_2,
              _hoisted_3
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_4, [
          (!_ctx.isEditCargo)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_DataWrapper, {
                    label: "Komoditas group (kargo)",
                    asterisk: "",
                    class: "w-full"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_CustomDropdown, {
                        class: "w-full my-2",
                        placeholder: "Pilih komoditas",
                        options: _ctx.commodityOptions,
                        onSelect: _ctx.onSelectCommodity,
                        selectedItem: _ctx.commodityItem,
                        isCustomWidth: ""
                      }, null, 8, ["options", "onSelect", "selectedItem"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DataWrapper, {
                    label: "Tipe produk kargo",
                    class: "w-full"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_Select, {
                        onOpenSelect: _ctx.onOpenSelectCargoProduct,
                        onCloseSelect: _ctx.onCloseSelectCargoProduct,
                        isOpenMenu: _ctx.isOpenSelectCargoProduct,
                        value: _ctx.formBooking.cargoProduct,
                        onChooseSelect: _ctx.onSelectCargoProduct,
                        dataSelect: _ctx.listProductCargo,
                        customClass: "w-full",
                        class: "w-full whitespace-no-wrap my-2 z-10"
                      }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DataWrapper, {
                    label: "NOG",
                    optional: "",
                    class: "w-full"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_LpInput, {
                        class: "w-full",
                        onChange: _ctx.onChangeNog,
                        modelValue: _ctx.formBooking.nog,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formBooking.nog = $event)),
                        placeholder: "Masukan NOG"
                      }, null, 8, ["onChange", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DataWrapper, {
                    label: "SHC",
                    optional: "",
                    class: "w-full"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_LpInput, {
                        disabled: "",
                        modelValue: _ctx.shcValue,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.shcValue = $event)),
                        placeholder: "Masukan SHC",
                        class: "w-full"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isEditCargo)
            ? (_openBlock(), _createBlock("div", _hoisted_8))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", {
              class: ['flex-col justify-start items-start gap-3 flex', { 'w-full': _ctx.isEditCargo }]
            }, [
              (!_ctx.isEditCargo)
                ? (_openBlock(), _createBlock("div", _hoisted_10, " Pilih jadwal pesawat "))
                : _createCommentVNode("", true),
              _createVNode("div", {
                class: `${!_ctx.isEditCargo? 'gap-5 grid grid-cols-2' : 'w-full'}`
              }, [
                _createVNode(_component_DataWrapper, { label: "Tanggal keberangkatan" }, {
                  default: _withId(() => [
                    _createVNode(_component_Datepicker, {
                      id: "date_picker_departure_date_modal_form_cargo_plane",
                      class: "my-1.5 w-full",
                      setDefaultDate: true,
                      minDate: new Date(),
                      modelValue: _ctx.form.estDepartureDate,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.estDepartureDate = $event)),
                      onSelected: _ctx.setPeriodeStart
                    }, null, 8, ["minDate", "modelValue", "onSelected"])
                  ]),
                  _: 1
                }),
                (
                  (_ctx.flowBooking.includes('rtc') && !_ctx.isEditCargo)
                )
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 0,
                      label: "Batas waktu pencarian"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_lp_input, {
                          suffix: "Menit",
                          placeholder: "0",
                          isErrorIconInput: false,
                          isErrorIconCaption: false,
                          modelValue: _ctx.form.thresholdTime,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.thresholdTime = $event)),
                          onChange: _ctx.onChangeThresholdTime,
                          error: +_ctx.form.thresholdTime < 1,
                          format: _ctx.numberOnly
                        }, null, 8, ["modelValue", "onChange", "error", "format"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_DataWrapper, { label: "Bandara asal" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_CustomDropdown, {
                        id: "select_origin_airport_modal_form_cargo_plane",
                        options: _ctx.optionAirportOrigin,
                        onSelect: _ctx.selectAirportOrigin,
                        placeholder: "Pilih bandara asal",
                        isCustomWidth: "",
                        selectedItem: _ctx.airportOrigin,
                        class: "w-full",
                        preventUnselect: ""
                      }, {
                        default: _withId(() => [
                          (!_ctx.selectAirportOrigin)
                            ? (_openBlock(), _createBlock("div", _hoisted_12, " Data tidak ditemukan "))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["options", "onSelect", "selectedItem"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DataWrapper, { label: "Bandara tujuan" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_13, [
                      _createVNode(_component_CustomDropdown, {
                        id: "select_destination_airport_modal_form_cargo_plane",
                        options: _ctx.optionAirportDestination,
                        onSelect: _ctx.selectAirportDestination,
                        placeholder: "Pilih bandara tujuan",
                        isCustomWidth: "",
                        selectedItem: _ctx.airportDestination,
                        class: "w-full",
                        preventUnselect: ""
                      }, {
                        default: _withId(() => [
                          (!_ctx.optionAirportDestination)
                            ? (_openBlock(), _createBlock("div", _hoisted_14, " Data tidak ditemukan "))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["options", "onSelect", "selectedItem"])
                    ])
                  ]),
                  _: 1
                }),
                (
                  (_ctx.flowBooking.includes('rtc') && _ctx.isEditCargo) || !_ctx.isRtc ||
                    (_ctx.flowBooking === 'rebooking' &&
                      _ctx.$route.query.rcId)
                )
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 1,
                      label: "Batas waktu pencarian",
                      class: "mb-4"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_lp_input, {
                          id: "input_threshold_time_modal_form_cargo_plane",
                          suffix: "Menit",
                          placeholder: "0",
                          isErrorIconInput: false,
                          modelValue: _ctx.form.thresholdTime,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.thresholdTime = $event)),
                          onChange: _ctx.onChangeThresholdTime,
                          error: +_ctx.form.thresholdTime > _ctx.tresholdMaxTime,
                          format: _ctx.numberOnly,
                          errorCaption: `Batas waktu pencarian melebihi batas maksimum ${_ctx.tresholdMaxTime} menit.`,
                          customClassSuffix: "customSuffix"
                        }, null, 8, ["modelValue", "onChange", "error", "format", "errorCaption"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isShowFieldWeight)
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      _createVNode(_component_DataWrapper, {
                        label: "Aktual Total Berat Kotor Kargo",
                        class: "w-1/2"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_lp_input, {
                            id: "weight_modal_form_cargo_plane",
                            suffix: "Kg",
                            placeholder: "0",
                            "model-value": _ctx.actualGrossWeight,
                            onChange: _ctx.onChangeTotalCargoGrossWeight,
                            format: _ctx.numberOnly,
                            disabled: !_ctx.isRtc,
                            disableBackground: ""
                          }, null, 8, ["model-value", "onChange", "format", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataWrapper, {
                        label: "Aktual Total Berat Volume Kargo",
                        class: "w-1/2"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_lp_input, {
                            id: "input_volume_weight_modal_form_cargo_plane",
                            suffix: "Kg",
                            placeholder: "0",
                            "model-value": _ctx.actualVolumeWeight,
                            onChange: _ctx.onChangeTotalCargoVolumeWeight,
                            format: _ctx.numberOnly,
                            disabled: !_ctx.isRtc,
                            disableBackground: ""
                          }, null, 8, ["model-value", "onChange", "format", "disabled"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2)
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode(_component_LpButton, {
            id: "button_cancel_modal_form_cargo_plane",
            onClick: _ctx.cancelPopupAirport,
            customClass: "px-8 py-2",
            title: "Batal",
            textColor: "red-lp-300",
            outline: ""
          }, null, 8, ["onClick"]),
          _createVNode(_component_LpButton, {
            id: "button_submit_next_modal_form_cargo_plane",
            onClick: _ctx.onCheckEligible,
            customClass: "px-8 py-2",
            title: "Lanjutkan",
            textColor: "white",
            disabled: _ctx.isDisabledAirport
          }, null, 8, ["onClick", "disabled"])
        ])
      ], 4)
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onReset"]))
})